export const NON_ZONED_CARD_LAYOUT = [
  [
    { tab: 'thermostat-rth', order: 1, pingdomId: 'thermostat-rth-container' },
    { tab: 'alerts', order: 4, pingdomId: 'alerts-container' },
    { tab: 'status', order: 8, pingdomId: 'thermostat-current-status-container' },
    { tab: 'awair-rth', order: 9, pingdomId: 'awair-rth-container' }
  ],
  [
    { tab: 'maintenance-trends', order: 2, pingdomId: 'maintenance-trends-container' },
    { tab: 'config-components', order: 5, pingdomId: 'sys-config-container' }
  ],
  [
    { tab: 'customer-runtime', order: 3, pingdomId: 'customer-runtime-status-container' },
    { tab: 'reports', order: 6, pingdomId: 'reports-container' },
    { tab: 'notes', order: 7, pingdomId: 'notes-container' }
  ]
]
export const ZONED_CARD_LAYOUT = [
  [
    { tab: 'thermostat-rth', order: 1, pingdomId: 'thermostat-rth-container' },
    { tab: 'alerts', order: 4, pingdomId: 'alerts-container' },
    { tab: 'status', order: 9, pingdomId: 'thermostat-current-status-container' }
  ],
  [
    { tab: 'maintenance-trends', order: 2, pingdomId: 'maintenance-trends-container' },
    { tab: 'config-components', order: 5, pingdomId: 'sys-config-container' },
    { tab: 'awair-rth', order: 8, pingdomId: 'awair-rth-container' }
  ],
  [
    { tab: 'customer-runtime', order: 3, pingdomId: 'customer-runtime-status-container' },
    { tab: 'reports', order: 6, pingdomId: 'reports-container' },
    { tab: 'notes', order: 7, pingdomId: 'notes-container' }
  ]
]

export default function determineCardLayout ({ isZoned }: { isZoned: boolean }) {
  return isZoned ? ZONED_CARD_LAYOUT : NON_ZONED_CARD_LAYOUT
}
